import { useCallback, useRef } from "react";

export const useScrollAnchor = () => {
  const scrollAnchorRef = useRef<HTMLDivElement>(null);

  const scrollToAnchor = useCallback(() => {
    scrollAnchorRef?.current?.scrollIntoView({
      behavior: "instant",
      block: "end",
    });
  }, [scrollAnchorRef]);

  const scrollToPrev = useCallback(() => {
    if (scrollAnchorRef !== null && scrollAnchorRef.current !== null) {
      scrollTo(scrollAnchorRef.current, "start", true);
    }
  }, [scrollAnchorRef]);

  const scrollToNext = useCallback(() => {
    if (scrollAnchorRef !== null && scrollAnchorRef.current !== null) {
      scrollTo(scrollAnchorRef.current, "end", true);
    }
  }, [scrollAnchorRef]);

  return { scrollAnchorRef, scrollToAnchor, scrollToNext, scrollToPrev };
};
export const scrollTo = (container: HTMLElement | null, position: "start" | "end", smooth = false) => {
  if (container?.children.length) {
    const lastElement = container?.lastChild as HTMLElement;
    lastElement?.scrollIntoView({
      behavior: smooth ? "smooth" : "auto",
      block: "end",
      inline: position,
    });
  }
};
